import { render } from "preact";
import { App } from "./app";
// MapLibre first so ours wins any specificity tie: its `.maplibregl-map`
// rule targets the same element as our `.map`.
import "maplibre-gl/dist/maplibre-gl.css";
import "./styles.css";

const root = document.getElementById("root");
if (root) render(<App />, root);
